import axios from "axios";

export const ApiConnector = axios.create({
    baseURL: import.meta.env.DEV ? 'http://127.0.0.1:8005' : 'https://waapi.myquickone.com',
    withCredentials: true,
    headers: { Accept : "application/json" },
});

ApiConnector.interceptors.request.use(config => config,
    error => { return Promise.reject(error); }
)

ApiConnector.interceptors.response.use(
    response => response,
    error => {
        if(error.response) {
            // if(error.response.status === 401 || error.response.status  === 419) {
            //     window.location.href = "/login";
            // } else { return Promise.reject(error); }
            return Promise.reject(error);
        } else if (error.request) {
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    }
);

async function requestApiToken (cat_user_id) {
    let res = await ApiConnector.post('/api/v1/authenticate', { cat_user_id });
    let data = {
        cat_user_id: cat_user_id,
        key: res.data.token
    };
    localStorage.setItem(
        import.meta.env.DEV ? 'waapi_token_dev' : 'waapi_token',
        JSON.stringify(data)
    );
    return data;
}

export const setToken = async(cat_user_id) => {
    let waapi_token = localStorage.getItem(
        import.meta.env.DEV ? 'waapi_token_dev' : 'waapi_token',
    );
    let data = null;

    if(!waapi_token) {
        data = await requestApiToken(cat_user_id);
    } else {
        data = JSON.parse(waapi_token);
        if(data.cat_user_id !== cat_user_id) {
            data = await requestApiToken(cat_user_id);
        }
    }
    ApiConnector.defaults.headers.common.Authorization = `Bearer ${data.key}`;
}
